{
    "UserNotificationBusyTime": "Receba uma notificação quando a sua equipa estiver ocupada.",
    "UserNotificationMissedCalls": "Receber uma notificação quando um determinado número de chamadas não forem atendidas num período de 60 minutos.",
    "UserNotificationWeeklyInsightsReport": "Receber um relatório semanal de desempenho.",
    "UserNotificationUserNotLoggedIn7Days": "Receber uma notificação quando não tiver iniciado sessão durante 7 dias.",
    "UserNotificationAvgAnswerTime": "Receber uma notificação quando o tempo médio de resposta exceder um determinado número de segundos em intervalos de meia hora.",
    "UserNotificationUserNeverLoggedIn": "Receber uma notificação quando não iniciar sessão.",
    "NAME": "UserNotificationTypesHelp"
}